export type TemplateSwitchImpactInput = {
  pendingTemplate: { behavior?: unknown } | null;
  currentTemplate: { behavior?: unknown } | null;
  hasExistingTasks: boolean;
  hasSelectedAssets: boolean;
};

export type TemplateSwitchImpact = {
  willLoseTasks: boolean;
  willLoseAssets: boolean;
  isChangingBehavior: boolean;
  isPendingAssetDriven: boolean;
  danger: boolean;
};

/**
 * Matches getTemplateBehavior + isAssetDrivenTemplate: GraphQL AssetRules
 * and internal asset_rules are asset-driven; everything else is static.
 */
function isAssetDriven(
  template: { behavior?: unknown } | null | undefined
): boolean {
  return (
    template?.behavior === 'AssetRules' || template?.behavior === 'asset_rules'
  );
}

/**
 * What a template switch will discard. Returns null when there is no
 * pending template (the warning dialog stays closed).
 */
export function getTemplateSwitchImpact({
  pendingTemplate,
  currentTemplate,
  hasExistingTasks,
  hasSelectedAssets,
}: TemplateSwitchImpactInput): TemplateSwitchImpact | null {
  if (!pendingTemplate) {
    return null;
  }

  const isCurrentAssetDriven = isAssetDriven(currentTemplate);
  const isPendingAssetDriven = isAssetDriven(pendingTemplate);

  const willLoseTasks = hasExistingTasks;
  const willLoseAssets = isCurrentAssetDriven && hasSelectedAssets;
  const isChangingBehavior = isCurrentAssetDriven !== isPendingAssetDriven;

  return {
    willLoseTasks,
    willLoseAssets,
    isChangingBehavior,
    isPendingAssetDriven,
    danger: willLoseTasks || willLoseAssets,
  };
}
